import React from 'react'
import { SVGIconProps } from '../types'
const SvgShortText = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M4 9h16v2H4zm0 4h10v2H4z" />
  </svg>
)
export default SvgShortText
